import axios from "axios";

export default {
    signUp: orgDetails =>
        axios.post(`/accounts/register/`, { ...orgDetails }).then(res => {
            console.log(res);
            return res;
        })
};
